var _excluded = ["as", "variant", "bold", "children", "className", "onClick"];
function cov_hjy6kpkyf() {
  var path = "/app/src/components/v2/typography/typography.tsx";
  var hash = "28fe1b7b88dc2a41a6fddf0c81d69cd444b4ab7f";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/app/src/components/v2/typography/typography.tsx",
    statementMap: {
      "0": {
        start: {
          line: 15,
          column: 23
        },
        end: {
          line: 15,
          column: 72
        }
      },
      "1": {
        start: {
          line: 26,
          column: 21
        },
        end: {
          line: 28,
          column: 25
        }
      },
      "2": {
        start: {
          line: 30,
          column: 2
        },
        end: {
          line: 44,
          column: 4
        }
      }
    },
    fnMap: {
      "0": {
        name: "Typography",
        decl: {
          start: {
            line: 17,
            column: 16
          },
          end: {
            line: 17,
            column: 26
          }
        },
        loc: {
          start: {
            line: 25,
            column: 29
          },
          end: {
            line: 45,
            column: 1
          }
        },
        line: 25
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 18,
            column: 6
          },
          end: {
            line: 18,
            column: 21
          }
        },
        type: "default-arg",
        locations: [{
          start: {
            line: 18,
            column: 18
          },
          end: {
            line: 18,
            column: 21
          }
        }],
        line: 18
      },
      "1": {
        loc: {
          start: {
            line: 26,
            column: 21
          },
          end: {
            line: 28,
            column: 25
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 27,
            column: 6
          },
          end: {
            line: 27,
            column: 25
          }
        }, {
          start: {
            line: 28,
            column: 6
          },
          end: {
            line: 28,
            column: 25
          }
        }],
        line: 26
      },
      "2": {
        loc: {
          start: {
            line: 34,
            column: 8
          },
          end: {
            line: 34,
            column: 27
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 34,
            column: 8
          },
          end: {
            line: 34,
            column: 12
          }
        }, {
          start: {
            line: 34,
            column: 16
          },
          end: {
            line: 34,
            column: 27
          }
        }],
        line: 34
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0
    },
    f: {
      "0": 0
    },
    b: {
      "0": [0],
      "1": [0, 0],
      "2": [0, 0]
    },
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "28fe1b7b88dc2a41a6fddf0c81d69cd444b4ab7f"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_hjy6kpkyf = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_hjy6kpkyf();
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import cn from 'classnames';
import React from 'react';
import styles from './styles.css';
var headingVariant = (cov_hjy6kpkyf().s[0]++, ['headingXL', 'heading1', 'heading2', 'H3', 'H4']);
export function Typography(_ref) {
  var _ref$as = _ref.as,
    Component = _ref$as === void 0 ? (cov_hjy6kpkyf().b[0][0]++, 'p') : _ref$as,
    variant = _ref.variant,
    bold = _ref.bold,
    children = _ref.children,
    className = _ref.className,
    onClick = _ref.onClick,
    props = _objectWithoutProperties(_ref, _excluded);
  cov_hjy6kpkyf().f[0]++;
  var fontFamily = (cov_hjy6kpkyf().s[1]++, headingVariant.includes(variant) ? (cov_hjy6kpkyf().b[1][0]++, 'fontFamilyHeading') : (cov_hjy6kpkyf().b[1][1]++, 'fontFamilyDefault'));
  cov_hjy6kpkyf().s[2]++;
  return /*#__PURE__*/React.createElement(Component, _extends({
    className: cn(styles.body, (cov_hjy6kpkyf().b[2][0]++, bold) && (cov_hjy6kpkyf().b[2][1]++, styles.bold), [styles[fontFamily]], [styles[variant]], className),
    onClick: onClick
  }, props), children);
}